import { handleAPI, API_VERSION_ONE_ADMIN } from '../../../utils/apiUtils';

export function findingSettingsLoad(filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/findings`;
  const method = 'GET'

  return {
    type: `FINDING_SETTINGS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function findingSettingCreate(data, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/findings`;
  const method = 'POST'

  return {
    type: `FINDING_SETTING_CREATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function findingSettingUpdate(data, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/findings/${data.id}`;
  const method = 'PUT'

  return {
    type: `FINDING_SETTING_UPDATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function findingSettingDelete(id, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/findings/${id}`;
  const method = 'DELETE'

  return {
    type: `FINDING_SETTING_DELETE`,
    payload: handleAPI(url, filters, method)
  };
}

export function findingSettingChange(data) {
  return {
    type: 'FINDING_SETTING_CHANGE',
    data,
  };
}

export function findingSettingChangeCancel() {
  return {
    type: 'FINDING_SETTING_CHANGE_CANCEL',
  };
}

export function findingSettingEdit(data) {
  return {
    type: 'FINDING_SETTING_EDIT',
    data,
  };
}

export function findingSettingEditCancel() {
  return {
    type: 'FINDING_SETTING_EDIT_CANCEL'
  };
}